import { jsxs as v, jsx as i } from "react/jsx-runtime";
import { E as p, S as d } from "./icons.types-0722eef5.js";
function m({ title: o, titleId: s, size: c, width: t, height: n, extended: l = !1, ...r }) {
  const a = l ? p : d, h = c ? a[c] : t || a[l ? "s" : "l"], e = c ? a[c] : n || a[l ? "s" : "l"];
  return /* @__PURE__ */ v(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 32",
      width: h,
      height: e,
      "aria-labelledby": s,
      ...r,
      children: [
        o ? /* @__PURE__ */ i("title", { id: s, children: o }) : null,
        /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            d: "M16.013 27.333c-1.573 0-3.047-.297-4.421-.892a11.476 11.476 0 0 1-3.594-2.426 11.477 11.477 0 0 1-2.426-3.594c-.595-1.374-.892-2.847-.892-4.42s.297-3.047.892-4.422a11.476 11.476 0 0 1 2.426-3.594 11.478 11.478 0 0 1 3.594-2.426c1.374-.595 2.848-.892 4.421-.892 1.677 0 3.27.352 4.78 1.057a11.318 11.318 0 0 1 3.887 2.974v-2.16c0-.283.096-.52.287-.712a.968.968 0 0 1 .713-.287c.284 0 .52.095.712.287.192.192.288.43.288.713v4.564c0 .341-.116.627-.347.858a1.166 1.166 0 0 1-.859.347H20.91a.967.967 0 0 1-.712-.288.968.968 0 0 1-.288-.713c0-.283.096-.52.288-.712a.968.968 0 0 1 .712-.287h2.488a10.078 10.078 0 0 0-3.29-2.67 8.913 8.913 0 0 0-4.095-.971c-2.6 0-4.806.905-6.617 2.716C7.586 11.195 6.68 13.4 6.68 16c0 2.6.905 4.806 2.716 6.617 1.811 1.81 4.017 2.716 6.617 2.716 2.154 0 4.07-.66 5.75-1.983 1.68-1.322 2.773-3.013 3.28-5.073.086-.279.237-.49.453-.633.216-.144.461-.198.734-.162.29.036.513.165.671.387a.829.829 0 0 1 .13.731c-.576 2.55-1.886 4.644-3.93 6.28-2.045 1.635-4.408 2.453-7.088 2.453Zm1-11.738 3.667 3.667a.966.966 0 0 1 .283.696.943.943 0 0 1-.283.709.957.957 0 0 1-.703.29.956.956 0 0 1-.702-.29l-3.9-3.9a1.2 1.2 0 0 1-.362-.864v-5.57c0-.283.096-.52.288-.712a.968.968 0 0 1 .712-.288c.284 0 .521.096.713.288.191.192.287.429.287.712v5.262Z"
          }
        )
      ]
    }
  );
}
export {
  m as ClockUpdate
};
